module.exports = __webpack_public_path__ + "static/media/document.1d4f7b6b.svg";